import Box from '@zenbusiness/zui/Box';
import Button from '@zenbusiness/zui/Button';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import { superstyled } from '@zenbusiness/zui/styles';

export const InvoicePaymentsHeaderRoot = superstyled({
  name: 'InvoicePaymentsHeader',
  slot: 'root',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(1.5, 3),
    backgroundColor: theme.palette.fixed.black,
  }),
});

export const InvoicePaymentsHeaderWordmark = superstyled({
  name: 'InvoicePaymentsHeader',
  slot: 'wordmark',
  tag: SharedAsset,
  propsAdded: {
    height: '30px',
  },
});

export const InvoicePaymentsHeaderButton = superstyled({
  name: 'InvoicePaymentsHeader',
  slot: 'button',
  tag: Button,
  propsAdded: {
    variant: 'contained',
    size: 'sm',
  },
  styles: ({ theme }) => ({
    backgroundColor: theme.palette.fixed.grey[800],
    color: theme.palette.fixed.white,
    '&:hover': {
      backgroundColor: theme.palette.fixed.grey[800],
    },
  }),
});
